import { SecurityConfirm } from 'components/index'
import Comission from 'pages/Captacao/Comission'
import DetalhesNewCaption from 'pages/Captacao/DetalhesNovaCaptacao/indexCopy'
import NovaCaptacao from 'pages/Captacao/NovaCaptacao'
import ResumoCaptacao from 'pages/Captacao/ResumoCaptacao'
import { hasAccess } from 'helper/utils'
import DetalhesComercial from './DetalhesComercial'
import DetalhesJuridico from './DetalhesJuridico'
import DetalhesContrato from './DetalhesContrato'
import DetalhesCliente from './DetalhesCliente'
import NovaConta from './NovaConta'

export const newAccount: any = [
  [<NovaConta />],
  [<SecurityConfirm hasButtonBack />],
]

export const gestor: any = [[<DetalhesComercial />]]

export const legal: any = [[<DetalhesJuridico />]]

export const contract: any = [[<DetalhesContrato />]]

export const account = [[<DetalhesCliente />]]

export const baseCaptacao: any = [
  [<NovaCaptacao />],
  [<SecurityConfirm hasButtonBack />],
]

export const novaCaptacao: any = [
  [<NovaCaptacao />],
  [<ResumoCaptacao />],
  [<DetalhesNewCaption />],
  [<Comission />],
  [<SecurityConfirm hasButtonBack />],
]

export const toggleDisabled = [
  ['Gestão de conta', 'account', true],
  ['Fluxo comercial', 'comercial', true],
  ['Fluxo jurídico', 'contract', true],
  ['Fluxo de contratos', 'captations', true],
  ['Saques', 'withdraw', true],
]
export const toggleOptionList = () => {
  return [
    ['Gestão de conta', 'account', !hasAccess('gestao-clients-toggle')],
    ['Fluxo comercial', 'comercial', !hasAccess('fluxo-comercial-toggle')],
    ['Fluxo jurídico', 'contract', !hasAccess('fluxo-juridico-toggle')],
    ['Fluxo de contratos', 'captations', !hasAccess('fluxo-contrato-toggle')],
    ['Saques', 'withdraw', true],
  ]
}
